import { memo, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { Box, Button } from '@/components'
import { useTranslations } from '@/core/translation'
import { ChevronLeftIcon, ChevronRightIcon } from '@/assets'
import { backAndForwardButtonsStyles as styles } from './BackAndForwardButtons.style'
import { BackAndForwardButtonsProps } from './BackAndForwardButtons.types'

function BackAndForwardButtons({
  skipButtonText,
  onSkipButtonClick,
  hideSkipButton = false,
  hideBackButton = false,
}: BackAndForwardButtonsProps) {
  const t = useTranslations('general')
  const navigate = useNavigate()

  const onBackClick = useCallback(() => navigate(-1), [navigate])

  return (
    <Box sx={styles.buttonWrapper}>
      <Box>
        {!hideBackButton && (
          <Button
            sx={styles.backButton}
            color="tertiary"
            textProps={{ sx: styles.buttonText }}
            startIcon={<ChevronLeftIcon />}
            onClick={onBackClick}>
            {t('back')}
          </Button>
        )}
      </Box>
      <Box>
        {!hideSkipButton && (
          <Button
            sx={styles.skipButton}
            color="tertiary"
            textProps={{ sx: styles.buttonText }}
            endIcon={<ChevronRightIcon />}
            onClick={onSkipButtonClick}>
            {skipButtonText}
          </Button>
        )}
      </Box>
    </Box>
  )
}

export default memo(BackAndForwardButtons)
